import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import printlogo from "../../printpropertise/printlogoceylonika.png";
import dayjs from "dayjs";


const pdfStyles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  headerSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#cccccc",
    paddingBottom: 10,
  },
  companyDetails: { flexDirection: "column" },
  logo: { width: 150, height: 45, marginBottom: 5 },
  companyName: { fontSize: 11, fontFamily: "Helvetica-Bold" },
  companyAddress: { fontSize: 9, maxWidth: 250 },
  reportInfo: { textAlign: "right" },
  reportTitle: { fontSize: 14, fontFamily: "Helvetica-Bold", marginBottom: 5 },
  reportDate: { fontSize: 9, marginBottom: 2 },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 20,
  },
  tableRow: { flexDirection: "row" },
  tableColHeader: {
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#e0e0e0",
    padding: 5,
    textAlign: "center",
    fontFamily: "Helvetica-Bold",
  },
  tableCol: {
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    justifyContent: "center",
  },
  tableCellHeader: { margin: "auto", fontSize: 9, fontFamily: "Helvetica-Bold" },
  tableCell: { fontSize: 8, paddingHorizontal: 2, paddingVertical: 2, overflow: "hidden", textAlign: "left" },
  tableCellRight: { fontSize: 8, paddingHorizontal: 2, paddingVertical: 2, overflow: "hidden", textAlign: "right" },
  summaryBox: {
    borderRadius: 5,
    backgroundColor: "#edfcfc",
    padding: 10,
    marginTop: 10,
    alignSelf: "flex-end",
    width: "40%",
  },
  summaryHeader: { backgroundColor: "#a0fae8", padding: 5, borderRadius: 5, marginBottom: 8, fontFamily: "Helvetica-Bold" },
  summaryRow: { flexDirection: "row", justifyContent: "space-between", marginVertical: 2 },
  summaryLabel: { fontSize: 9, fontFamily: "Helvetica-Bold" },
  summaryValue: { fontSize: 9 },
  footer: { position: "absolute", bottom: 30, left: 35, right: 35, textAlign: "center", color: "grey", fontSize: 8 },
});

export const MonthEndSaleSummaryPDF = ({ data, dateRange }) => {
  const totalDailySales = data.reduce((sum, item) => sum + (item.dailysales || 0), 0);
  const totalBP = data.reduce((sum, item) => sum + (item.dailyBp || 0), 0);

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page} orientation="landscape">
        {/* Header */}
        <View style={pdfStyles.headerSection} fixed>
          <View style={pdfStyles.companyDetails}>
            <Image src={printlogo} style={pdfStyles.logo} />
            <Text style={pdfStyles.companyName}>Ceylonika Cosmetics (Pvt) Ltd</Text>
            <Text style={pdfStyles.companyAddress}>154/11, Pushparama Road, Kadawatha</Text>
            <Text style={pdfStyles.companyAddress}>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
            <Text style={pdfStyles.companyAddress}>+94 112 92 44 20</Text>
          </View>
          <View style={pdfStyles.reportInfo}>
            <Text style={pdfStyles.reportTitle}>Month-End Sale Summary Report</Text>
            <Text style={pdfStyles.reportDate}>
              Date Range: {dayjs(dateRange[0]).format("YYYY-MM-DD")} to {dayjs(dateRange[1]).format("YYYY-MM-DD")}
            </Text>
            <Text style={pdfStyles.reportDate}>Print Date/Time: {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}</Text>
          </View>
        </View>

        {/* Table Header */}
        <View style={pdfStyles.table}>
          <View style={pdfStyles.tableRow} fixed>
            {[
              { label: "Year", width: "5%" },
              { label: "Month", width: "5%" },
              { label: "Sales Date", width: "10%" },
              { label: "New Starts", width: "5%" },
              { label: "New Recruits", width: "5%" },
              { label: "New Recruits Orders Count", width: "5%" },
              { label: "New Recruits Sales Total", width: "10%" },
              { label: "Sales Force", width: "5%" },
              { label: "Inactive Consultants Count", width: "5%" },
              { label: "Reactive Consultants Count", width: "5%" },
              { label: "Orders Placed Consultants Count", width: "5%" },
              { label: "BP Orders Count", width: "5%" },
              { label: "Daily Sales", width: "10%" },
              { label: "Cumulative Sales", width: "10%" },
              { label: "Daily BP", width: "5%" },
              { label: "Cumulative BP", width: "5%" },
            ].map((col) => (
              <View key={col.label} style={[pdfStyles.tableColHeader, { width: col.width }]}>
                <Text style={pdfStyles.tableCellHeader}>{col.label}</Text>
              </View>
            ))}
          </View>

          {/* Table Rows */}
          {data.map((item, idx) => (
            <View style={pdfStyles.tableRow} key={idx} wrap={false}>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.sysYear}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.sysMonth}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "10%" }]}>
                <Text style={pdfStyles.tableCell}>{dayjs(item.salesDate).format("YYYY-MM-DD")}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.newStarts}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.newRecruits}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.dailyNewRecruitsOrderCount}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "10%" }]}>
                <Text style={pdfStyles.tableCellRight}>{item.dailyNewRecruitsSales.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.salesForce}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.inactiveConsultants}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.reactiveConsultants}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.dailyOrderConsultants}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCell}>{item.dailyBPOrderCount}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "10%" }]}>
                <Text style={pdfStyles.tableCellRight}>{item.dailysales.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "10%" }]}>
                <Text style={pdfStyles.tableCellRight}>{item.cumSales.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCellRight}>{item.dailyBp}</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "5%" }]}>
                <Text style={pdfStyles.tableCellRight}>{item.cumBp}</Text>
              </View>
            </View>
          ))}
        </View>

        {/* Summary */}
        <View style={pdfStyles.summaryBox}>
          <Text style={pdfStyles.summaryHeader}>Summary</Text>
          <View style={pdfStyles.summaryRow}>
            <Text style={pdfStyles.summaryLabel}>Total Sales:</Text>
            <Text style={pdfStyles.summaryValue}>{totalDailySales.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
          </View>
          <View style={pdfStyles.summaryRow}>
            <Text style={pdfStyles.summaryLabel}>Total BP:</Text>
            <Text style={pdfStyles.summaryValue}>{totalBP}</Text>
          </View>
          <View style={pdfStyles.summaryRow}>
            <Text style={pdfStyles.summaryLabel}>Total Records:</Text>
            <Text style={pdfStyles.summaryValue}>{data.length}</Text>
          </View>
        </View>

        {/* Footer */}
        <Text
          style={pdfStyles.footer}
          render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
          fixed
        />
      </Page>
    </Document>
  );
};
